import { Injectable } from "@angular/core";
import { v4 as uuidv4 } from "uuid";

@Injectable({
  providedIn: "root"
})
export class UuidService {
  /**
   * Generates a new v4 UUID.
   * @returns A new UUID string.
   */
  public v4(): string {
    return uuidv4();
  }
}